import type { QueryClient } from "@tanstack/react-query";

import { tournamentReplayMetricsQuery, tournamentTeamStatsQuery } from "@/entities/replay-metrics";
import { tournamentStatsCoverageQuery } from "@/widgets/tournament-detail/tournament-stats-coverage-note";

import { tournamentMvpQuery } from "./mvp-section";

/**
 * Прогрев запросов блока итогов (KAN-993).
 *
 * Блок монтируется только после команд и снимка архива (без них не собрать
 * пьедестал, а рисовать его позже — сдвиг макета). Его собственные запросы
 * зависят лишь от id турнира, но стартовали третьей волной — замер на проде:
 * +220 мс к команде/снимку. Прогрев запускает их вместе с командами и снимком;
 * компоненты берут те же опции, поэтому ключи совпадают по построению, а
 * повторного запроса при монтировании нет (данные свежие, либо запрос в полёте).
 */
export function prefetchTournamentResults(queryClient: QueryClient, tournamentId: string): void {
  void queryClient.prefetchQuery(tournamentMvpQuery(tournamentId));
  void queryClient.prefetchQuery(tournamentReplayMetricsQuery(tournamentId));
  void queryClient.prefetchQuery(tournamentTeamStatsQuery(tournamentId));
  void queryClient.prefetchQuery(tournamentStatsCoverageQuery(tournamentId));
}
